export default __webpack_public_path__ + "static/overlay-wheel-afe518db1887eaeea66fc31e0f6b0403.webp";